import SidebarAndPanesWithRouting from '@/components/layouts/SidebarAndPanesWithRouting.vue';
import featureFlags from '@/store/modules/featureFlags';
import get from 'lodash/get';
import SmartAssistPanel from './children/SmartAssistPanel.vue';
import LynqAIMetrics from './children/LynqAIMetrics.vue';

const showSmartAssistMetrics = get(featureFlags, 'state.FEATURE_FLAGS.SHOW_SMART_ASSIST_METRICS', false);
const showLynqAIMetrics = get(featureFlags, 'state.FEATURE_FLAGS.SHOW_LYNQ_AI_METRICS', false);

const rootRoute = {
  path: 'ai',
  name: 'AiMetrics',
  component: SidebarAndPanesWithRouting,
  meta: {
    auth: true,
    label: 'AI',
  },
  props: {
    baseResource: '/metrics/ai',
    singleRouterView: true,
  },
};

const commonChildMeta = {
  auth: true,
  resource: rootRoute.path,
  parentName: rootRoute.name,
};

const childRoutes = [
  ...(showSmartAssistMetrics ? [{
    path: 'smart_assist',
    name: 'Metrics.AiMetrics.SmartAssist',
    component: SmartAssistPanel,
    meta: {
      label: 'Smart Assist',
      ...commonChildMeta,
    },
  }] : []),
  ...(showLynqAIMetrics ? [{
    path: 'lynq_ai',
    name: 'Metrics.AiMetrics.LynqAI',
    component: LynqAIMetrics,
    meta: {
      label: 'Lynq AI',
      ...commonChildMeta,
    },
  }] : []),
];

rootRoute.props.children = childRoutes;

export default {
  ...rootRoute,
  children: childRoutes,
};
